import { AccountDetailsTable } from "@bitwarden/web-vault/app/components/tables/account-tables/account-details-table/account-details.table";
import { AccountSymbolTable } from "@bitwarden/web-vault/app/components/tables/account-tables/account-symbol-table/account-symbol-table";
import { AccountViewTable } from "@bitwarden/web-vault/app/components/tables/account-tables/account-view-table/account-view.table";
import { SymbolTable } from "@bitwarden/web-vault/app/components/tables/symbol-table/symbol.table";
import { CabinetTable } from "@bitwarden/web-vault/app/components/tables/cabinet-table/cabinet.table";
import { TablesType } from "@bitwarden/web-vault/app/models/enum/tables.enum";
import { TableParent } from "@bitwarden/web-vault/app/models/types/table.types";
import { PastTransactionTable } from "@bitwarden/web-vault/app/components/tables/transaction-table/past-transaction.table";
import { ScenarioTransactionTable } from "@bitwarden/web-vault/app/components/tables/transaction-table/scenario-transaction.table";
import { LicenseManager } from "ag-grid-enterprise";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { InstitutionDetailsTable } from "@bitwarden/web-vault/app/components/tables/institution-tables/institution-details-table/institution-details.table";
import { EarnDraftTable } from "@bitwarden/web-vault/app/components/tables/earn-tables/tables/draft/earn-draft.table";
import { EarnViewTable } from "@bitwarden/web-vault/app/components/tables/earn-tables/tables/view/earn-view.table";
import { EarnVersionTable } from "@bitwarden/web-vault/app/components/tables/earn-tables/tables/version/earn-version.table";
// import { CategoryTable } from "@bitwarden/web-vault/app/components/tables/category-table/category.table";
import { CategoryTable } from "@bitwarden/web-vault/app/components/tables/category-tables/category.table";
import { ClassificationTable } from "@bitwarden/web-vault/app/components/tables/classification-tables/classification.table";
import { BudgetTable } from "@bitwarden/web-vault/app/components/tables/budget-tables/budget.table";
import { BudgetHistoryTable } from "@bitwarden/web-vault/app/components/tables/budget-tables/budget-history-table/budget-history.table";

/* Set license */
LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-063300}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Ironfly_Technologies_Limited}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{GLOSS_Vault}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{GLOSS_Vault}_need_to_be_licensed___{GLOSS_Vault}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{11_July_2025}____[v3]_[01]_MTc1MjE4ODQwMDAwMA==78426cc29fbc2c22bf97224bbd624392",
);

/** Factory type map **/
export type TableTypeMap = {
  [TablesType.AccountView]: AccountViewTable;
  [TablesType.AccountDetails]: AccountDetailsTable;
  [TablesType.AccountSymbol]: AccountSymbolTable;
  [TablesType.Symbol]: SymbolTable;
  [TablesType.Cabinet]: CabinetTable;
  [TablesType.PastTransactions]: PastTransactionTable;
  [TablesType.ScenarioTransactions]: ScenarioTransactionTable;
  [TablesType.InstitutionDetails]: InstitutionDetailsTable;
  [TablesType.RedactionDraft]: EarnDraftTable;
  [TablesType.RedactionView]: EarnViewTable;
  [TablesType.EarnVersion]: EarnVersionTable;
  [TablesType.Categories]: CategoryTable;
  [TablesType.Classifications]: ClassificationTable;
  [TablesType.Budget]: BudgetTable;
  [TablesType.BudgetHistory]: BudgetHistoryTable;
};

export class TablesFactory {
  get<K extends TablesType>(type: K, parent?: TableParent): TableTypeMap[K] {
    switch (type) {
      case TablesType.AccountView:
        return new AccountViewTable() as TableTypeMap[K];
      case TablesType.AccountDetails:
        return new AccountDetailsTable(parent) as TableTypeMap[K];
      case TablesType.AccountSymbol:
        return new AccountSymbolTable() as TableTypeMap[K];
      case TablesType.Symbol:
        return new SymbolTable() as TableTypeMap[K];
      case TablesType.Cabinet:
        return new CabinetTable(parent) as TableTypeMap[K];
      case TablesType.PastTransactions:
        return new PastTransactionTable() as TableTypeMap[K];
      case TablesType.ScenarioTransactions:
        return new ScenarioTransactionTable() as TableTypeMap[K];
      case TablesType.InstitutionDetails:
        return new InstitutionDetailsTable(parent) as TableTypeMap[K];
      case TablesType.RedactionDraft:
        return new EarnDraftTable(parent) as TableTypeMap[K];
      case TablesType.RedactionView:
        return new EarnViewTable(parent) as TableTypeMap[K];
      case TablesType.EarnVersion:
        return new EarnVersionTable(parent) as TableTypeMap[K];
      case TablesType.Categories:
        return new CategoryTable(parent) as TableTypeMap[K];
      case TablesType.Classifications:
        return new ClassificationTable(parent) as TableTypeMap[K];
      case TablesType.Budget:
        return new BudgetTable(parent) as TableTypeMap[K];
      case TablesType.BudgetHistory:
        return new BudgetHistoryTable(parent) as TableTypeMap[K];
      default:
        throw new Error(`Unknown table type: ${type}`);
    }
  }
}
